{
  "id": "001-011",
  "title": "Planning ahead",
  "layout": {
    "offset": "even-row",
    "tiles": {
      "0": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "wall",
              "directions": [
                2,
                3,
                4
              ],
              "immutable": true,
              "id": "599155e1"
            }
          ],
          "id": "190532c5"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 0,
              "id": "b1400b19"
            }
          ],
          "id": "84eab54c",
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "f1c5bbea"
            }
          ]
        },
        "2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 0
                }
              ],
              "id": "61f27708"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "827e9a99"
            }
          ],
          "id": "97a17408"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 1,
              "id": "977950c8"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "2cb4c742"
            }
          ],
          "id": "c37a03f6"
        },
        "-3": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1
                }
              ],
              "id": "73f8a5ac"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "3990e750"
            }
          ],
          "id": "c548f15d"
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "wall",
              "directions": [
                3,
                4,
                5
              ],
              "immutable": true,
              "id": "597f2783"
            }
          ],
          "id": "6ba442c5"
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 0
                }
              ],
              "id": "9334ca61"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "524e1e3e"
            }
          ],
          "id": "706f6c74"
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "id": "a9aad9b7"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "87f186bb"
            }
          ],
          "id": "961e9705"
        },
        "2": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 0,
              "id": "4611479d"
            }
          ],
          "id": "b44b0f4c"
        },
        "-3": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "id": "51e6e20a"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "dde316f3"
            }
          ],
          "id": "255e99c6"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1
                }
              ],
              "id": "20030ebf"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "d467956f"
            }
          ],
          "id": "665ba31e"
        },
        "-4": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 1,
              "id": "e0fbb677"
            }
          ],
          "id": "b87f2624"
        }
      },
      "2": {
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 0,
              "id": "90899ba7"
            }
          ],
          "id": "c5d2f81f"
        },
        "2": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 0
                }
              ],
              "id": "2aad73ec"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "55583307"
            }
          ],
          "id": "fb70627d"
        },
        "-3": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1
                }
              ],
              "id": "71a24791"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "505368dc"
            }
          ],
          "id": "314490e3"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "portal",
              "direction": 1,
              "id": "0266f740"
            }
          ],
          "id": "e7e92e61"
        }
      },
      "-1": {
        "0": {
          "id": "1b76a8a0",
          "type": "tile",
          "items": [
            {
              "type": "wall",
              "directions": [
                2,
                3
              ],
              "immutable": true,
              "id": "d74a298d"
            }
          ]
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 0
                },
                {
                  "color": "#0000ff",
                  "direction": 1
                },
                {
                  "color": "#ff0000",
                  "direction": 2
                },
                {
                  "color": "#0000ff",
                  "direction": 3
                },
                {
                  "color": "#ff0000",
                  "direction": 4
                },
                {
                  "color": "#0000ff",
                  "direction": 5
                }
              ],
              "id": "e7a7ae2f"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "99f4e45e"
            },
            {
              "type": "rotate",
              "id": "44b7fd07"
            },
            {
              "type": "toggle",
              "id": "b022e1bd"
            }
          ],
          "id": "5a1ac900"
        },
        "-2": {
          "type": "tile",
          "items": [
            {
              "type": "wall",
              "directions": [
                4
              ],
              "immutable": true,
              "id": "7e95cc73"
            }
          ],
          "id": "bc09e30f"
        }
      },
      "-2": {
        "0": {
          "id": "eadb402e",
          "type": "tile"
        },
        "-1": {
          "id": "92e29b3a",
          "type": "tile"
        }
      }
    },
    "modifiers": [
      {
        "type": "move",
        "id": "d94e4efb"
      },
      {
        "type": "move",
        "id": "8c3989d1"
      },
      {
        "type": "rotate",
        "id": "554016e6"
      },
      {
        "type": "rotate",
        "id": "a1a4421a"
      }
    ]
  },
  "version": 0,
  "requirements": [
    {
      "type": "connections",
      "amount": 6
    }
  ]
}
